'use client';

import Close from '@hc-frontend/core-icons/kit/close';
import Info from '@hc-frontend/core-icons/kit/info';
import { addClassName } from '@hc-frontend/core-utils-format';
import { useState } from 'react';

export function Banner({
  className,
  message,
}: {
  className?: string;
  message?: string;
}) {
  const [open, setOpen] = useState(true);

  if (!open || !message) {
    return null;
  }

  return (
    <div
      className={addClassName(
        'flex gap-16-16 items-center justify-between rounded-lg border-[0.5px] border-[#0083E1] px-16-32 py-12-12 bg-[#D9EBFF]',
        className,
      )}
    >
      <div className="hidden rounded-full bg-[#0083E1] p-4-4 tablet:block">
        <Info className="size-24-24 text-gray-0" />
      </div>
      <p className="hc-typography--paragraph-sm flex-1">{message}</p>
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="flex size-24-24 min-h-24-24 min-w-24-24 items-center justify-center rounded-full bg-gray-0"
        aria-label="close"
      >
        <Close className="size-16-16 text-gray-200" />
      </button>
    </div>
  );
}
